import { mapShoppingCartConfigurationBundlesToUpdate } from "../adapters/configuration.adapter";
import httpClient from "../config/httpClient";
import { CustomerType } from "../models/customer";
import { ShoppingCartConfigurationBundleDto, ShoppingCartConfigurationDto } from "../models/shoppingCart.model";
import { ShoppingCartExtrasBundleDto } from "../shopping-cart";

const v1Url = `${process.env.VUE_APP_API_URL}/v1/api`;
export abstract class ShoppingCartService {
	private static readonly BASE_URL = "/sys03/";
	private static readonly SHOPPING_CART_URL = ShoppingCartService.BASE_URL.concat("shopping-cart");
	private static readonly AVAILABLE_PRODUCTS_URL = "available-products";
	private static readonly DEFAULT_SUMMARY_URL = "available-product";
	private static readonly SUMMARY_URL = "summary";
	private static readonly EXTRAS_URL = "extras";
	private static readonly CONFIGURATION_URL = "configuration";

	public static create(apartmentId: string, customerType: CustomerType, products?: any) {
		return httpClient.post(this.SHOPPING_CART_URL, {
			apartmentId,
			customerType,
			products
		});
	}

	public static getAvailableProducts(apartmentId: string, customerType: CustomerType) {
		const url = `${v1Url}${ShoppingCartService.SHOPPING_CART_URL}/${ShoppingCartService.AVAILABLE_PRODUCTS_URL}`;
		return httpClient.post(url, {
			apartmentId,
			customerType
		});
	}

	/**
	 * Gets the default shopping cart summary according to a product
	 * @param shoppingCartId
	 * @param productName
	 */
	public static getDefaultSummary(shoppingCartId: string, productName: string) {
		const url = `${v1Url}${ShoppingCartService.SHOPPING_CART_URL}/${shoppingCartId}/${ShoppingCartService.DEFAULT_SUMMARY_URL}/${productName}`;
		return httpClient.get(url);
	}

	/**
	 * Gets the shopping cart summary
	 * @param shoppingCartId
	 */
	public static getSummary(shoppingCartId: string) {
		const url = `${v1Url}${ShoppingCartService.SHOPPING_CART_URL}/${shoppingCartId}/${ShoppingCartService.SUMMARY_URL}`;
		return httpClient.get(url);
	}

	public static getExtras(shoppingCartId: string) {
		const url = `${v1Url}${ShoppingCartService.SHOPPING_CART_URL}/${shoppingCartId}/${ShoppingCartService.EXTRAS_URL}`;
		return httpClient.get<ShoppingCartExtrasBundleDto[]>(url);
	}

	public static putExtras(shoppingCartId: string, extraBundles: any) {
		const url = `${v1Url}${ShoppingCartService.SHOPPING_CART_URL}/${shoppingCartId}/${ShoppingCartService.EXTRAS_URL}`;

		const formattedExtras = extraBundles.map((bundle) => {
			return {
				name: bundle.name,
				extras: bundle.extras,
				extraGroups: bundle.extraGroups
			};
		});

		return httpClient.put(url, formattedExtras);
	}

	public static getConfiguration(shoppingCartId: string) {
		const url = `${v1Url}${ShoppingCartService.SHOPPING_CART_URL}/${shoppingCartId}/${ShoppingCartService.CONFIGURATION_URL}`;
		return httpClient.get<ShoppingCartConfigurationDto>(url);
	}

	public static putConfiguration({ id, bundles = [] }: { id: string; bundles: ShoppingCartConfigurationBundleDto[] }) {
		const url = `${v1Url}${ShoppingCartService.SHOPPING_CART_URL}/${id}/${ShoppingCartService.CONFIGURATION_URL}`;
		const body = mapShoppingCartConfigurationBundlesToUpdate(bundles);

		return httpClient.put<ShoppingCartConfigurationDto>(url, body);
	}
}
